import React, { Component } from "react"
import PropTypes from "prop-types"

import "bootstrap/dist/css/bootstrap.min.css"
import "./layout.scss"
import Footer from "./footer/Footer"
import Navigation from "./navigation/Navigation"

  class Layout extends Component {
    state = {
      position: "-7rem",
      lastScrollY: 80,
    }

    componentDidMount() {
      if (typeof window !== "undefined") {
        window.addEventListener("scroll", this.handleScroll)
      }
    }

    componentWillUnmount() {
      if (typeof window !== "undefined") {
        window.removeEventListener("scroll", this.handleScroll)
      }
    }


    handleScroll = () => {
      const { lastScrollY } = this.state
      const currentScrollY = window.scrollY

      if (currentScrollY > lastScrollY) {
        this.setState({ position: "0" })
      } else {
        this.setState({ position: "-7rem" })
      }

      this.setState({ lastScrollY: currentScrollY })
    }

    render() {
      const { position } = this.state
      const { children } = this.props

      return (
        <div className="layout">
          <Navigation position={position}/>
          <main>{children}</main>
          <Footer/>
        </div>
      )
    }
  }


Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
